(function(angular) {
    angular.module('bizPartEngage').controller('modules.educationsList', bizEducationsListController);
    angular.module('bizPartEngage').controller('modules.educationsListModule', bizEducationsListModuleController);
    angular.module('bizPartEngage').directive('bizModuleEducationList', bizModuleEducationListDirective);
    angular.module('bizPartEngage').directive('bizEducationsList', bizEducationsListDirective);
    
    bizEducationsListDirective.$inject = ["bizCore"];
    bizModuleEducationListDirective.$inject = ["bizCore"];
    bizEducationsListController.$inject = ["modules.education.service", "$state", "$stateParams", "container", "$filter", "$translate", "MetadataService", "$scope"];

    bizEducationsListModuleController.$inject = ["$rootScope", "modules.education.service", "$translate", "$filter"];

    function bizEducationsListDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
                settings: "=?"
            },
            templateUrl: bizCoreProvider.getView('core.directives.educationlist', 'FrontEnd/Modules/Education/Views/educationslistdirective.html'),
            controller: bizCoreProvider.getController('base.modules.educationsList', 'modules.educationsList'),
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    function bizModuleEducationListDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
                settings: "=?"
            },
            templateUrl: function (element, attr) {
                if (attr.templateurl) {
                    return siteRootPath + attr.templateurl;
                } else {
                    return bizCoreProvider.getView('core.directives.educationlist', 'FrontEnd/Modules/Education/Views/education-list.html');
                }
            },
            controller: bizCoreProvider.getController('base.modules.educationsListModule', 'modules.educationsListModule'),
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    function bizEducationsListController(educationService, $state, $stateParams, container, $filter, $translate, MetadataService, $scope) {
        var vm = this;

        vm.DataLoaded = false;

        vm.TagId = ~~$stateParams.tagId;
        vm.TagSystemName = $stateParams.tagSystemName;

        vm.useJourneyOrder = journeySettings?.UseJourneyOrderInLists?.GetItemByValue('Key', 1)?.Value || false;

    	vm.SCORMUserStatus = {
    		NotStarted: 0,
    		Started: 1,
    		Passed: 2,
    		Failed: 3
    	};

        var skipLoadContainer = true;

		//todo merge, same list?
        vm.HTML5Educations = [];
        vm.SCORMEducations = [];

        vm.EduItems = [];
        vm.AllItems = [];

        vm.GetAllEducationTypes = GetAllEducationTypes;
        vm.GetHTML5EducationsForLoggedInUser = GetHTML5EducationsForLoggedInUser;
        vm.GetSCORMEducations = GetSCORMEducations;
        vm.OpenEducation = OpenEducation;
        vm.HandleCategoryForEduction = HandleCategoryForEduction;
        vm.ApplyTagFilter = ApplyTagFilter;

        vm.TagFilter = TagFilter;
        vm.GetTag = GetTag;

        function GetHTML5EducationsForLoggedInUser() {
            var tagIds = vm.TagId ? [vm.TagId] : undefined;

            if (tagIds !== undefined) {
                educationService.GetHTML5EducationsForLoggedInUserByTagId(tagIds, vm.useJourneyOrder).then(GetHTML5EducationsForLoggedInUserSuccess);
            }
            else {
                educationService.GetHTML5EducationsForLoggedInUser(skipLoadContainer, vm.useJourneyOrder).then(GetHTML5EducationsForLoggedInUserSuccess);
            }
            

            function GetHTML5EducationsForLoggedInUserSuccess(response) {
                var list = response.data;
                vm.Tags = [];
                vm.Categories = [];
                vm.HTML5Educations = [];

                for (var i = 0; i < list.length; i++) {
                    var edu = list[i];
                    edu.TypeKey = 'EDUCATION';
                    edu.State = 'base.modules.html5education({id:' + (edu.UrlRewrite ? '"'+ edu.UrlRewrite +'"' : edu.Id) + '})';

                    if ((edu.Description == null || edu.Description == "") && skipLoadContainer == false) {
                        edu.Container = new container(edu.Container);
                        var modules = edu.Container.getModules("Text");

                        if (modules == null || modules.length <= 0) {
                            modules = edu.Container.getModules("ImageText");
                        }

                        if (modules != null && modules.length > 0) {
                            edu.Description = $filter('bizPlaceholders')(modules[0].Content.Text);
                        }
                    }

                    if (vm.HandleCategoryForEduction(edu)) {
                        
                    } else {
                        vm.HTML5Educations.push(edu);
                    }

                    if (!edu.Tags || !edu.Tags.length)
                        continue;

                    for (var j = 0; j < edu.Tags.length; j++) {
                        if (!vm.Tags.GetItemByValue("Id", edu.Tags[j].Id))
                            vm.Tags.push(edu.Tags[j]);
                    }
                }

                vm.AllItems = vm.AllItems.concat(vm.HTML5Educations);
                vm.ApplyTagFilter();

                vm.DataLoaded = true;
            }
        }

        function ApplyTagFilter() {
            var normalizedTagId = parseInt(vm.TagId, 10);

            if (!normalizedTagId) {
                vm.EduItems = vm.AllItems || [];
                return;
            }

            vm.EduItems = (vm.AllItems || []).filter(function (item) {
                return HasTag(item, normalizedTagId);
            });
        }

        function HasTag(item, normalizedTagId) {
            if (!item)
                return false;

            if (item.TagIds && item.TagIds.length > 0) {
                for (var j = 0; j < item.TagIds.length; j++) {
                    if (parseInt(item.TagIds[j], 10) === normalizedTagId) {
                        return true;
                    }
                }
            }

            if (item.IsCategory && item.Entries && item.Entries.length) {
                for (var j = 0; j < item.Entries.length; j++) {
                    if (HasTag(item.Entries[j], normalizedTagId))
                        return true;
                }
            }

            return false;
        }

        function HandleCategoryForEduction(edu) {
            if (!edu.GenericCategories || !edu.GenericCategories.length)
                return false;

            for (var i = 0; i < edu.GenericCategories.length; i++) {
                var category = vm.Categories.GetItemByValue('Id', edu.GenericCategories[i].Id);
                if (!category) {
                    category = edu.GenericCategories[i];
                    category.Entries = [];
                    category.Selected = edu;
                    category.IsCategory = true;
                    vm.Categories.push(category);
                    vm.HTML5Educations.push(category);
                }
                category.Entries.push(edu);
            }

            return true;
        }

        function GetTag(callback) {
            if (vm.TagSystemName || vm.TagId) {
                if (vm.TagSystemName) {
                    educationService.GetTagBySystemName(vm.TagSystemName).then(GetTagSuccess);
                } else {
                    educationService.GetTag(vm.TagId).then(GetTagSuccess);
                }

                function GetTagSuccess(response) {
                    vm.SelectedTag = vm.TagSystemName ? response.data : response.data[0];
                    vm.TagId = vm.SelectedTag.Id;

                    if (callback) {
                        callback();
                    }
                }
            }
            else {
                if (callback) {
                    callback();
                }
            }
        }

        function TagFilter(tagId) {
        	return function (item) {
        		return item.Tags && item.Tags.GetItemByValue('Id', tagId);
        	}
        }

        function GetSCORMEducations() {
        	educationService.GetSCORMEducations().then(GetSCORMEducationsSuccess);

        	function GetSCORMEducationsSuccess(response) {
        		vm.SCORMEducations = BizPartCoreHelpers.getResponseValue(response, []);
        		for (var i = 0; i < vm.SCORMEducations.length; i++) {
        			var edu = vm.SCORMEducations[i];
                    edu.UserHasPassed = edu.Status == vm.SCORMUserStatus.Passed;
        			edu.Url = siteRootPath + 'scorm/' + edu.Id;
                    edu.TypeKey = 'SCORM';
                    edu.State = 'base.modules.scormeducation({id:' + edu.Id + '})';
        		}

                vm.AllItems = vm.AllItems.concat(vm.SCORMEducations);
                vm.ApplyTagFilter();
        	}
        }

        function OpenEducation(education) {
            if(education.TypeKey === 'SCORM') {
                $state.go('base.modules.scormeducation', { id: education.Id });
            }
            else {
                $state.go('base.modules.html5education', {id: education.UrlRewrite || education.Id});
            }
        }

        function GetAllEducationTypes() {
            vm.GetHTML5EducationsForLoggedInUser();
            vm.GetSCORMEducations();
        }

        vm.$onInit = function () {
            vm.GetTag(GetAllEducationTypes);

            $scope.$watch(function () {
                return vm.settings && vm.settings.selectedTagId;
            }, function (newVal, oldVal) {
                if (newVal === oldVal) return;

                vm.TagId = newVal;
                vm.ApplyTagFilter();
            });
        }
    }

    function bizEducationsListModuleController($rootScope, educationService, $translate, $filter) {
        var vm = this;
        vm.HTML5Educations = [];
        

        vm.Init = Init;

        function InitObjectMiniList() {

            console.log("educationlist settings", vm.settings, vm.HTML5Educations);
            vm.ItemsForMiniObjectList = [];

            /*vm.OverrideTypeLabel = $filter("bizPhrase")("ONE_ITEM_EDUCATION");*/

            for (var i = 0; i < vm.HTML5Educations.length; i++) {
                var listItem = vm.HTML5Educations[i];

                var miniObject = {
                    Id: listItem.Id,
                    Name: listItem.Name,
                    Description: listItem.Description,
                    ImageUrl: listItem.ImageUrl,
                    EngageObjects: [],
                    Url: { state: 'base.modules.html5education', params: { id: listItem.UrlRewrite || listItem.Id } }
                };

                //if (vm.OverrideTypeLabel != null)
                //    miniObject.OverrideTypeLabel = vm.OverrideTypeLabel;

                vm.ItemsForMiniObjectList.push(miniObject);
            }
        }

        function Init() {
            if(!vm.settings.Filter && vm.settings.SelectedFilter) vm.settings.Filter = vm.settings.SelectedFilter.Value;
            if(!vm.settings.Limit && vm.settings.SelectedLimit) vm.settings.Limit = vm.settings.SelectedLimit.Value;

            if(vm.settings.Filter == 'newest') {
                educationService.GetHTML5EducationsForLoggedInUser().then(GetEducationsSuccess);
            }
            else if(vm.settings.Filter == 'journey') {
                if($rootScope.FavoriteTagIds.length > 0) {
                    educationService.GetHTML5EducationsForLoggedInUserByTagId($rootScope.FavoriteTagIds, true).then(GetEducationsSuccess);
                }
                else {
                    educationService.GetHTML5EducationsForLoggedInUser(false, true).then(GetEducationsSuccess);
                }
            }

            function GetEducationsSuccess(response) {
                vm.HTML5Educations = response.data;

                InitObjectMiniList();
            }
        }

        vm.$onInit = vm.Init;

        if (angular.version.major === 1 && angular.version.minor < 5) {
            vm.$onInit();
        }
    }

})(window.angular);